import MerchantRedirect from './MerchantRedirect';

export default MerchantRedirect;
